import cn from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './Badge.module.scss';

export type BadgeTone = 'neutral' | 'violet' | 'success' | 'danger';

export type BadgeVariant = 'soft' | 'solid';

export type BadgeSize = 'small' | 'medium';

export type BadgeProps = {
  children: ReactNode;
  className?: string;
  testID?: string;
  tone?: BadgeTone;
  variant?: BadgeVariant;
  size?: BadgeSize;
  dot?: boolean;
};

export const Badge: FC<BadgeProps> = (props) => {
  const {
    children,
    className,
    testID,
    tone = 'neutral',
    variant = 'soft',
    size = 'medium',
    dot = false,
  } = props;

  return (
    <span
      data-testid={testID}
      className={cn(
        styles.container,
        styles[tone],
        styles[variant],
        styles[size],
        size === 'small' ? 'p4' : 'p3b',
        className,
      )}
    >
      {dot && <span className={styles.dot} />}

      {children}
    </span>
  );
};
